import { Text } from '@carouselgg/nexus/text'

export function Loading() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'var(--nexus-space-3xl)',
      minHeight: '200px',
    }}>
      <Text muted>Loading...</Text>
    </div>
  )
}
